import React from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion"

const ProductItem = ({ product, containFilter }) => {
  return (
    <AnimatePresence>
    <motion.div layout
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
     className={"group relative border border-gray-200 rounded-lg p-3 bg-white shadow-sm hover:shadow-md transition-shadow flex flex-col " + (containFilter ? "flex" : "hidden")}>
      <div className="w-full h-48 sm:h-56 lg:h-64 rounded-md overflow-hidden relative text-center">
        <img
          src={product.img[0]}
          alt={product.alt}
          className="w-full h-full object-center object-contain transition-transform group-hover:scale-105"
        />
      </div>
      <div className="mt-3 flex-1 flex flex-col">
        <Link to={`/products/${product._id}`} className="cursor-pointer flex-1">
          <span aria-hidden="true" className="absolute inset-0" />
          <p className="company uppercase text-orange font-bold text-[0.625rem] tracking-wider pb-1">
            {product.company}
          </p>
          <h3 className="product capitalize text-very-dark-blue text-sm sm:text-base font-bold leading-tight pb-2 line-clamp-2">
            {product.title}
          </h3>
        </Link>
        <div className="flex justify-start items-center text-sm mt-auto">
          <div className="price font-bold text-base sm:text-lg">
            ₹{product.price}
          </div>
        </div>
      </div>
    </motion.div>
    </AnimatePresence>
  );
};

export default ProductItem;
